import cookie from 'js-cookie';

import { COUPON_COOKIE } from '~/features/cookies/constants';

/**
 * If the "coupon" cookie is set, return the value of the cookie, using js-cookie.
 */

export function getCouponCodeFromCookie() {
  return cookie.get(COUPON_COOKIE);
}
